<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				MkPasswd
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						パスワードを自動生成します。8-64桁のパスワードを最大128個まで一度に生成する事ができます。
					</p>
					<ul>
						<li>「除外文字」に指定した文字は除外して生成されます</li>
						<li>「追加文字」に指定した文字は候補文字に追加されます</li>
						<li>「記号」に含まれる文字は「#$%&-=?@[]_」です</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="e-grid -triple">
					<div class="col">
						<div class="e-label-list">
							<label class="e-label">
								<span class="label">桁数:</span>
								<input type="number" class="e-input-text -smallest -center" min="8" max="64" v-model="options.length" :class="{'-invalid': errors.length}">
							</label>
							<label class="e-label">
								<span class="label">生成数:</span>
								<input type="number" class="e-input-text -smallest -center" min="1" max="128" v-model="options.count" :class="{'-invalid': errors.count}">
							</label>
						</div>
						<label class="e-label -block">
							<span class="label">除外文字:</span>
							<input type="text" class="e-input-text" v-model="options.except">
						</label>
						<label class="e-label -block">
							<span class="label">追加文字:</span>
							<input type="text" class="e-input-text" v-model="options.additional">
						</label>
					</div>
					<div class="col">
						<h3>使用文字</h3>
						<label class="e-label">
							<span class="label">
								<input type="checkbox" v-model="options.character" value="upper">
								<span class="label">アルファベット大文字</span>
							</span>
						</label>
						<label class="e-label">
							<span class="label">
								<input type="checkbox" v-model="options.character" value="lower">
								<span class="label">アルファベット小文字</span>
							</span>
						</label>
						<label class="e-label">
							<span class="label">
								<input type="checkbox" v-model="options.character" value="number">
								<span class="label">数字</span>
							</span>
						</label>
						<label class="e-label">
							<span class="label">
								<input type="checkbox" v-model="options.character" value="symbol">
								<span class="label">記号</span>
							</span>
						</label>
					</div>
					<div class="col">
						<p>
							<button class="e-button -primary -full" @click="generate">生成</button>
						</p>
						<transition name="fade">
							<p v-if="results.length">
								<button class="e-button -link -full" @click="copy">結果をクリップボードにコピー</button>
							</p>
						</transition>
					</div>
				</div>
			</div>

			<hr class="e-hr">

			<div class="e-section">
				<transition name="slide-in">
					<div class="c-mkpasswd-result" v-if="results.length">
						<ul class="c-mkpasswd-result__list">
							<li class="c-mkpasswd-result__item" v-for="item in results">{{item}}</li>
						</ul>
					</div>
				</transition>
				<transition name="slide-in">
					<div class="c-error-list" v-if="errorMessages.length">
						<ul class="c-error-list__list">
							<li class="c-error-list__item" v-for="error in errorMessages">
								<c-icon :name="'error'"></c-icon>
								{{error}}
							</li>
						</ul>
					</div>
				</transition>
			</div>

		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";
import mkPasswd from "../lib/mkpasswd";
import validation from "../lib/validation";

export default {
	mixins: [
		mCommon
	],
	data (){
		return {
			options: {
				length: 16,
				count: 32,
				except: "0",
				additional: "",
				character: ["upper", "lower", "number", "symbol"]
			},
			errors: {
				length: null,
				count: null,
				except: null,
				additional: null,
				character: null
			},
			results: []
		}
	},
	computed: {
		errorMessages (){
			var errors = [];
			$.each(this.errors, (key, value) => {
				if(value){
					errors.push(value.message);
				}
			});
			return errors;
		}
	},
	methods: {
		generate (){
			// 一旦初期化
			this.results = [];

			// バリデーション
			var valid = validation.get("mkpasswd").test(this.options, this.errors);

			if(valid){
				mkPasswd.config(this.options);
				this.results = mkPasswd.generate();
			}

		},
		copy (){
			var r = $.clipboard(this.results.join("\n"));
			if(! r){
				alert("クリップボードへのコピーに失敗しました");
			}
			if(r){
				alert("クリップボードへコピーされました");
			}
		}
	}
}

</script>


// WEBPACK FOOTER //
// mkpasswd.vue?455e5790